import axios from 'axios';
import { ISubdivisionsShortCollection } from 'common/models';
import {
  IBasketCollection,
  IBasketListParams,
  IBasket,
  ICreateBasketRequestPayload,
  IUpdateBasketPayload,
  IBasketListSubdivisionsParams,
  IBasketStoreCollection,
  IBasketStoresPayload,
  IBasketDeliveryPayload,
  IBasketDelivery,
} from 'entities/Basket/Basket.models';

const basePath = 'basket';

export const basketTransport = {
  get: (params: IBasketListParams): Promise<IBasketCollection> => axios.get(`${basePath}`, { params }),
  getById: (id: number): Promise<IBasket> => axios.get(`${basePath}/${id}`),
  update: (payload: IUpdateBasketPayload): Promise<IBasket> => axios.patch(`${basePath}`, payload),
  createRequest: (payload: ICreateBasketRequestPayload): Promise<IBasket> => axios.post(`${basePath}/request`, payload),
  uploadExcel: (id: number): Promise<ArrayBuffer> => axios.get(`${basePath}/excel/${id}`, { responseType: 'arraybuffer' }),
  getSubdivisions: (params: IBasketListSubdivisionsParams): Promise<ISubdivisionsShortCollection> =>
    axios.get(`${basePath}/subdivisions`, { params }),
  getStores: (payload: IBasketStoresPayload): Promise<IBasketStoreCollection> => axios.post(`${basePath}/stores`, payload),
  getDelivery: (payload: IBasketDeliveryPayload): Promise<IBasketDelivery> => axios.post(`${basePath}/delivery`, payload),
};
